export default "__VITE_ASSET__GU0mKaD$__"